import { useAuth } from '../../context/AuthContext';

function LocationSelectorForForm({ userRole, value, onChange, locations, label = "Kies Locatie" }) {
  const { userInfo } = useAuth();
  const is_single_user = userInfo?.is_single_user;

  if (userRole !== 'super_admin') return null;
  if (is_single_user) return null;

  return (
    <div className="form-group mb-3">
      <label>{label}</label>

      <select
        className="form-control"
        value={value}
        onChange={onChange}
      >
        <option value="">— Geen selectie —</option>

        {locations.map((loc) => (
          <option key={loc.location_id} value={loc.location_id}>
            {loc.customer_location_number} — {loc.location_name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LocationSelectorForForm;